import { Typography } from '@mui/material';

import BaseOutlinedInput from '@/components/shared/Form/BaseOutlinedInput';
import theme from '@/theme';

interface GenerateApiKeyStepProps {
  onGenerateApiKey: () => void;
  systemName: string;
  onSystemNameChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> | undefined;
  systemError: string | null;
}

function GenerateApiKeyStep({ onGenerateApiKey, systemName, onSystemNameChange, systemError }: GenerateApiKeyStepProps) {
  return (
    <>
      <Typography sx={{ ...theme.hhglobal.typography.body.large }}>
        You are about to generate an API key for an external system. The secret key will only be shown once.
      </Typography>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          onGenerateApiKey();
        }}
        id='external-system-form'
      >
        <BaseOutlinedInput
          id='external-system-id'
          name='external-system-name'
          inputLabel='External System Name'
          placeholder='Enter external system name'
          type='text'
          value={systemName}
          onChange={onSystemNameChange}
          isRequired
          /* As we provide only hardcoded systemName value we disable this field to prevent any additional generations */
          isDisabled
          size='small'
          isFullWidth
          errorMessage={systemError}
        />
      </form>
    </>
  );
}

export default GenerateApiKeyStep;
